import Axios from "axios";
import QueryOptions from "../sal-ui/QueryOptions";
import PagedResult from "./PagedResult";
import Interest from "../domain/Interest";
import {InterestMemory} from "../domain/InterestMemory";

class InterestService {

    readonly basePath = "/interests";

    public getMemory(id: string): Promise<InterestMemory> {
        return Axios.get(`${this.basePath}/${id}/memory`).then(value => value.data);
    }

    public updateMemoryRule(id: string, ruleId: string, text: string): Promise<void> {
        return Axios.put(`${this.basePath}/${id}/memory/${ruleId}`, {text});
    }

    public deleteMemoryRule(id: string, ruleId: string): Promise<void> {
        return Axios.delete(`${this.basePath}/${id}/memory/${ruleId}`);
    }

    public add(interest: Interest): Promise<string> {
        return Axios.post(`${this.basePath}`, interest).then(value => value.data.id);
    }

    public update(id: string, interest: Interest): Promise<void> {
        return Axios.put(`${this.basePath}/${id}`, interest);
    }

    public get(id: string): Promise<Interest> {
        return Axios.get(`${this.basePath}/${id}`)
            .then(value => Interest.fromPOJO(value.data));
    }

    public delete(interest: Interest): Promise<void> {
        return Axios.delete(`${this.basePath}/${interest.id}`);
    }

    public getList(queryOptions: QueryOptions): Promise<PagedResult<Interest>> {
        const query = queryOptions.toQueryParams();
        const url = `${this.basePath}?${query}`;

        return Axios.get(url)
            .then(value => {
                const list = value.data.data.map((objectJson: object) => Interest.fromPOJO(objectJson));
                return new PagedResult(value.data.total, list);
            });
    }
}

export default InterestService;
